import { Table, Button } from '@enterprise-ui/canvas-ui-react';
import React from 'react';
import { isDayDisabledCheck, isWeeklyDisabledCheck, selectedDayCheck, selectedWeekCheck } from '../utils/utility.js';

function RawCalendarDates(_ref) {
  var autoOk = _ref.autoOk,
    disableDates = _ref.disableDates,
    monthArr = _ref.monthArr,
    selectedDate = _ref.selectedDate,
    setDate = _ref.setDate,
    setIsCalendarVisible = _ref.setIsCalendarVisible;
  return /*#__PURE__*/React.createElement(React.Fragment, null, monthArr && monthArr.map(function (mon, index) {
    return /*#__PURE__*/React.createElement(Table, {
      name: "Retail Date Picker",
      className: "C-DatePicker__Table",
      key: "month_".concat(mon)
    }, /*#__PURE__*/React.createElement(Table.Head, null, /*#__PURE__*/React.createElement(Table.Row, {
      key: "month_week_".concat(mon)
    }, /*#__PURE__*/React.createElement(Table.Header, {
      key: "week_".concat(mon),
      xs: true,
      className: "hc-ta-left hc-pl-normal"
    }, "Retail Week"), /*#__PURE__*/React.createElement(Table.Header, {
      key: "Sunday_".concat(mon)
    }, "Su"), /*#__PURE__*/React.createElement(Table.Header, {
      key: "Monday_".concat(mon)
    }, "Mo"), /*#__PURE__*/React.createElement(Table.Header, {
      key: "Tuesday_".concat(mon)
    }, "Tu"), /*#__PURE__*/React.createElement(Table.Header, {
      key: "Wednesday_".concat(mon)
    }, "We"), /*#__PURE__*/React.createElement(Table.Header, {
      key: "Thursday_".concat(mon)
    }, "Th"), /*#__PURE__*/React.createElement(Table.Header, {
      key: "Friday_".concat(mon)
    }, "Fr"), /*#__PURE__*/React.createElement(Table.Header, {
      key: "Saturday_".concat(mon)
    }, "Sa"))), /*#__PURE__*/React.createElement(Table.Body, null, mon.monthArr && mon.monthArr.map(function (week, weekIndex) {
      return /*#__PURE__*/React.createElement(Table.Row, {
        key: "week_".concat(weekIndex)
      }, week.map(function (day, dayIndex) {
        var isDisabled = isDayDisabledCheck(day, disableDates);
        var isWeekDisabled = isWeeklyDisabledCheck(day, disableDates);
        var isSelected = selectedDayCheck(isDisabled, selectedDate, day);
        var isSelectedWeek = selectedWeekCheck(isDisabled, selectedDate, day);
        var type = day.type;
        return type === 'week' ? /*#__PURE__*/React.createElement(Table.Data, {
          className: "".concat(isDisabled ? 'isDisabled' : '', " date_").concat(weekIndex, " C-DatePicker__DataCell C-DatePicker__DataWeekCell  ").concat(day && isSelectedWeek ? 'isSelected' : ''),
          key: "date_".concat(weekIndex)
        }, /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          className: "C-DatePicker__WeekButton --embeddedInComponent ".concat(day && isSelectedWeek ? 'isSelected' : '', "\n                            ").concat(isDisabled ? 'isDisabled' : '', "\n                            "),
          disabled: isWeekDisabled,
          onClick: function onClick() {
            setDate(day.dateObj);
            autoOk && setIsCalendarVisible(false);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "C-DatePicker__WeekNumber"
        }, day.weekNo), /*#__PURE__*/React.createElement("span", null, day.weekName))) : /*#__PURE__*/React.createElement(Table.Data, {
          className: "C-DatePicker__DataCell",
          key: "date_".concat(weekIndex, "_").concat(dayIndex)
        }, /*#__PURE__*/React.createElement(Button, {
          iconOnly: true,
          disabled: isDisabled,
          "aria-hidden": day.value ? null : 'true',
          "aria-label": day.value ? day.value : 'hidden',
          onClick: function onClick() {
            setDate(day.dateObj);
            autoOk && setIsCalendarVisible(false);
          },
          className: "C-DatePicker__DateButton --embeddedInComponent ".concat(day && isSelected ? 'isSelected' : '', "\n                            ").concat(isDisabled ? 'isDisabled' : '', "\n                            ")
        }, day.dateNumber));
      }));
    })));
  }));
}
RawCalendarDates.displayName = 'CalendarDates';
var CalendarDates = /*#__PURE__*/React.memo(RawCalendarDates);

export { CalendarDates as default };
